module.exports = "/_next/static/images/1820beda527375f7135f980159399bb3-roxinho-scene-card-with-phone-lg@2x.jpg.webp";